import { TranslationKey } from 'src/typings/translation';

export interface NavItem {
  name: TranslationKey;
  icon?: string;
  route?: string;
  hidden?: boolean;
  disabled?: boolean;
  children?: NavItemChild[];
}

export interface NavItemChild {
  name: TranslationKey;
  route: string;
}

export const NavItems: NavItem[] = [
  {
    name: 'dashboard',
    route: '/',
    icon: 'la-tachometer-alt'
  },
  {
    name: 'lab',
    icon: 'la-flask',
    children: [
      {
        name: 'product.plural',
        route: '/products'
      },
      {
        name: 'mixture.plural',
        route: '/mixtures'
      },
      {
        name: 'specification.plural',
        route: '/specifications'
      },
      {
        name: 'grade.corrections',
        route: '/corrections'
      }
    ]
  },
  {
    name: 'basedata',
    icon: 'la-server',
    children: [
      {
        name: 'grade.plural',
        route: '/grades'
      },
      {
        name: 'runSystem.plural',
        route: '/runsystems'
      },
      {
        name: 'parameter.plural',
        route: '/parameters'
      },
      {
        name: 'parameterGroup.plural',
        route: '/parametergroups'
      },
      {
        name: 'method.plural',
        route: '/methods'
      },
      {
        name: 'instrument.plural',
        route: '/instruments'
      },
      {
        name: 'instrumentGroup.plural',
        route: '/instrumentgroups'
      },
      {
        name: 'plant.plural',
        route: '/plants'
      },
      {
        name: 'productType.plural',
        route: '/producttypes'
      },
      {
        name: 'segment.plural',
        route: '/segments'
      },
      {
        name: 'pallet.plural',
        route: '/pallets'
      },
      {
        name: 'labelTemplate.plural',
        route: '/labeltemplates'
      },
      {
        name: 'packaging.plural',
        route: '/packagings'
      },
      {
        name: 'customer.plural',
        route: '/customers'
      },
      {
        name: 'recipient.plural',
        route: '/recipients'
      },
      {
        name: 'mixtureType.plural',
        route: '/mixturetypes'
      }
    ]
  },
  // {
  //   name: 'production',
  //   icon: 'la-industry',
  //   route: '/production',
  //   disabled: true
  // },
  {
    name: 'report.plural',
    icon: 'la-chart-bar',
    children: [
      {
        name: 'certificate.plural',
        route: '/certificates'
      },
      {
        name: 'parameterSet.plural',
        route: '/parametersets'
      }
    ]
  },
  {
    name: 'import.singular',
    icon: 'la-file-import',
    children: [
      {
        name: 'import.gdms',
        route: '/importgdms'
      },
      {
        name: 'import.camsizer',
        route: '/importcamsizer'
      },
      {
        name: 'import.norlab',
        route: '/importnorlab'
      },
      {
        name: 'import.eurofins',
        route: '/importeurofins'
      }
    ]
  }
];
